import { render, staticRenderFns } from "./folders-vessels-option.vue?vue&type=template&id=42e38a5d&scoped=true"
import script from "./folders-vessels-option.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e38a5d",
  null
  
)

export default component.exports